/* Bare cart — drawer + cart page.
 * Defines <cart-drawer> so Shrine's product-form / quick-add hand added items straight to it.
 * Public API: window.BareCart.open(), .close(), .refresh(), .add(items), .afterAdd()
 */
(function () {
  if (customElements.get('cart-drawer')) return;

  var drawerEl = null;
  var state = null;
  var lastFocus = null;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents) {
    var fmt = (drawerEl && drawerEl.dataset.moneyFormat) || '${{amount}}';
    var v = (cents || 0) / 100;
    function sep(n, dec, thou, sepDec) {
      var parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(sepDec);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return sep(v, 0, ',', '.');
        case 'amount_with_comma_separator': return sep(v, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return sep(v, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return sep(v, 2, "'", '.');
        case 'amount_with_space_separator': return sep(v, 2, ' ', ',');
        default: return sep(v, 2, ',', '.');
      }
    });
  }

  function sizedImage(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function lineHTML(item, i) {
    var line = i + 1;
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    var plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
      ? item.selling_plan_allocation.selling_plan.name : '';
    var discounts = (item.line_level_discount_allocations || []).map(function (d) {
      return '<div class="bc-disc">' + esc(d.discount_application.title) + ' (−' + money(d.amount) + ')</div>';
    }).join('');
    var props = '';
    if (item.properties) {
      Object.keys(item.properties).forEach(function (k) {
        var val = item.properties[k];
        if (k.charAt(0) === '_' || val === '' || val == null) return;
        props += '<div class="bc-meta">' + esc(k) + ': ' + esc(val) + '</div>';
      });
    }
    var strike = item.original_line_price > item.final_line_price ? '<s>' + money(item.original_line_price) + '</s>' : '';
    return '' +
      '<div class="bc-line" data-line="' + line + '" data-key="' + esc(item.key) + '">' +
        '<a class="bc-img" href="' + esc(item.url) + '">' + (item.image ? '<img src="' + esc(sizedImage(item.image, 240)) + '" alt="' + esc(item.product_title) + '" loading="lazy" width="84" height="84">' : '') + '</a>' +
        '<div>' +
          '<a class="bc-title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
          (variant ? '<div class="bc-meta">' + esc(variant) + '</div>' : '') +
          props +
          (plan ? '<span class="bc-plan">↻ ' + esc(plan) + '</span>' : '') +
          discounts +
          '<div class="bc-ctrl">' +
            '<div class="bc-qty">' +
              '<button type="button" data-bc-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity of ' + esc(item.product_title) + '">−</button>' +
              '<span aria-label="Quantity">' + item.quantity + '</span>' +
              '<button type="button" data-bc-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity of ' + esc(item.product_title) + '">+</button>' +
            '</div>' +
            '<button type="button" class="bc-remove" data-bc-qty="0">Remove</button>' +
          '</div>' +
        '</div>' +
        '<div class="bc-price">' + strike + money(item.final_line_price) + '</div>' +
      '</div>';
  }

  function renderRoot(root, cart) {
    if (!root) return;
    var empty = !cart.items || cart.items.length === 0;
    root.querySelectorAll('[data-bc-empty]').forEach(function (el) { el.hidden = !empty; });
    root.querySelectorAll('[data-bc-full]').forEach(function (el) { el.hidden = empty; });
    root.querySelectorAll('[data-bc-lines]').forEach(function (el) {
      el.innerHTML = empty ? '' : cart.items.map(lineHTML).join('');
    });
    var itemsSubtotal = cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price;
    var discHTML = (cart.cart_level_discount_applications || []).map(function (d) {
      return '<div class="bc-row disc"><span>' + esc(d.title) + '</span><span>−' + money(d.total_allocated_amount) + '</span></div>';
    }).join('');
    root.querySelectorAll('[data-bc-discounts]').forEach(function (el) { el.innerHTML = discHTML; });
    root.querySelectorAll('[data-bc-items-subtotal]').forEach(function (el) { el.textContent = money(itemsSubtotal); });
    root.querySelectorAll('[data-bc-total]').forEach(function (el) { el.textContent = money(cart.total_price); });
    root.querySelectorAll('[data-bc-count-label]').forEach(function (el) {
      el.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    });
  }

  function updateCounts(cart) {
    document.querySelectorAll('[data-bare-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    // Shrine header bubble (other pages)
    var icon = document.getElementById('cart-icon-bubble');
    if (icon) {
      var bubble = icon.querySelector('.cart-count-bubble');
      if (cart.item_count > 0) {
        if (!bubble) {
          bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble';
          bubble.innerHTML = '<span aria-hidden="true"></span>';
          icon.appendChild(bubble);
        }
        var n = bubble.querySelector('span[aria-hidden]');
        if (n) n.textContent = cart.item_count < 100 ? cart.item_count : '';
      } else if (bubble) {
        bubble.remove();
      }
    }
  }

  function render(cart) {
    state = cart;
    renderRoot(drawerEl, cart);
    renderRoot(document.querySelector('.bare-cart-page'), cart);
    updateCounts(cart);
    document.dispatchEvent(new CustomEvent('bare:cart:updated', { detail: { cart: cart } }));
  }

  function fetchCart() {
    return fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', {
      headers: { Accept: 'application/json' }, credentials: 'same-origin'
    }).then(function (r) { return r.json(); });
  }

  function refresh() { return fetchCart().then(function (c) { render(c); return c; }); }

  function changeLine(lineEl, qty) {
    var key = lineEl.getAttribute('data-key');
    document.querySelectorAll('.bc-line[data-key="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]').forEach(function (el) { el.classList.add('is-busy'); });
    return fetch(drawerEl.dataset.changeUrl + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) {
          return refresh().then(function () {
            var el = document.querySelector('.bc-line[data-key="' + key + '"]');
            if (el) el.insertAdjacentHTML('beforeend', '<div class="bc-err">' + esc(data.description || data.message || 'Could not update quantity.') + '</div>');
          });
        }
        render(data);
      });
    }).catch(refresh);
  }

  function open() {
    if (!drawerEl) return;
    lastFocus = document.activeElement;
    drawerEl.classList.add('is-open');
    drawerEl.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var panel = drawerEl.querySelector('.bc-panel');
    setTimeout(function () { panel && panel.focus(); }, 50);
  }

  function close() {
    if (!drawerEl) return;
    drawerEl.classList.remove('is-open');
    drawerEl.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function onCartPage() { return !!document.querySelector('.bare-cart-page'); }

  function afterAdd() {
    return refresh().then(function (c) { if (!onCartPage()) open(); return c; });
  }

  function add(items) {
    return fetch(drawerEl.dataset.addUrl + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) { throw new Error(data.description || data.message || 'Could not add to cart.'); }
        return afterAdd();
      });
    });
  }

  class BareCartDrawer extends HTMLElement {
    connectedCallback() {
      drawerEl = this;
      var self = this;
      this.addEventListener('click', function (e) {
        if (e.target.closest('[data-bc-close]')) { e.preventDefault(); close(); }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.classList.contains('is-open')) close();
      });
      // initial state from the page, then keep it fresh
      try {
        var s = document.getElementById('BareCartState');
        if (s) render(JSON.parse(s.textContent));
      } catch (err) { /* ignore */ }
    }
    // Interface used by Shrine's product-form.js / quick-add.js
    getSectionsToRender() { return []; }
    setActiveElement(el) { lastFocus = el; }
    renderContents() { afterAdd(); }
    open() { open(); }
    close() { close(); }
  }
  customElements.define('cart-drawer', BareCartDrawer);

  // quantity / remove buttons (drawer + cart page)
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-bc-qty]');
    if (q) {
      var line = q.closest('.bc-line');
      if (line) { e.preventDefault(); changeLine(line, parseInt(q.getAttribute('data-bc-qty'), 10)); }
      return;
    }
    // open drawer from any cart link / icon (except on the cart page itself)
    var opener = e.target.closest('[data-bare-cart-open], #cart-icon-bubble');
    if (opener && drawerEl && !onCartPage() && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
      e.preventDefault();
      refresh();
      open();
    }
  });

  window.BareCart = { open: open, close: close, refresh: refresh, add: add, afterAdd: afterAdd, money: money };

  // refresh when the page is restored from the back/forward cache
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
})();
